import Vue from "vue";

export const collapseCSSReactive = Vue.observable({ value: [] });

export default {
  get() {
    return collapseCSSReactive.value;
  },
  set(active) {
    collapseCSSReactive.value = active;
  },
};
